<template>
  <div>
    <my-table
      :data="data"
      :loading="loading"
      :headers="headers"
      :query="query"
      @delete="handleDelete"
      @search="handleSearch"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
      @refresh="handleRefresh"
    >
      <template v-slot:actions>
        <my-button @click="handleSms" type="primary" v-if="name === 'current'" icon="chat-alt-2">Mass sms!</my-button>
      </template>
    </my-table>
    <mass-sms v-model:visible="visibleMassSms" />
  </div>
</template>
<script>
import * as _ from 'lodash'
import listMethods from '../../utils/listMethods'
import listData from '../../utils/listData'
import massSms from '../../components/contract/massSms.vue'
export default {
  components: {
    massSms
  },
  data () {
    return {
      ...listData,
      listApiUrl: '/contracts',
      visibleMassSms: false,
      headers: [{
        name: 'regNo',
        caption: 'Гэрээний дугаар',
        width: '100px'
      }, {
        prop: 'statusId',
        name: 'status.name',
        tableName: 'contract_status',
        caption: 'Төлөв',
        width: '100px',
        color: 'status.color',
        type: 'lookup'
      }, {
        name: '{treatment.treatmentAt} {treatmentDay}',
        caption: 'Эмчилгээний огноо',
        group: true,
        width: '100px',
        placeholder: 'Хойшилсон'
      }, {
        name: 'customer.registerNum',
        caption: 'Регистрийн дугаар',
        width: '100px'
      }, {
        name: 'customer.lastName',
        caption: 'Овог',
        width: '130px'
      }, {
        name: 'customer.firstName',
        caption: 'Нэр',
        width: '130px'
      }, {
        name: 'customer.isProblem',
        caption: 'Асуудалтай эсэх?',
        width: '90px',
        type: 'Boolean'
      }, {
        name: 'customer.isDrunk',
        caption: 'Уусан эсэх?',
        width: '90px',
        type: 'Boolean'
      }, {
      //   name: 'customer.birthAimagCity.name',
      //   caption: 'Аймаг',
      //   width: '130px'
      // }, {
      //   name: 'soumdDistrict.name',
      //   caption: 'Сум',
      //   width: '130px'
      // }, {
        name: 'createdAt',
        caption: 'Бүртгэсэн огноо',
        type: 'Date',
        width: '100px'
      }, {
        name: 'createdBy.firstName',
        caption: 'Бүртгэсэн хэрэглэгч',
        width: '110px'
      }],
      visible: false,
      itemId: null,
      query: { page: 1, limit: 15, sort: [], search: [] }
    }
  },
  computed: {
    name () {
      return this.$route.params.name
    }
  },
  watch: {
    name () {
      this.handleRefresh()
    }
  },
  beforeMount () {
    this.getList()
  },
  beforeUnmount () {
    this.handleCancelToken()
  },
  methods: {
    ...listMethods,
    async handleSms () {
      try {
        // await this.showConfirm({ message: 'Та одоо эмчилгээнд орох үйлчлүүлэгчдийн бүх дугаар луу мессеж илгээхдээ итгэлтэй байна уу?' })
        this.visibleMassSms = true
        // this.showToast('Уучлаарай. Засвартай байна.', 'warning')
      } catch (err) {
        this.handleError(err)
      }
    },
    async handleDelete (id) {
      try {
        await this.showConfirm({ message: 'Та тухайн бүртгэлийг устгахдаа итгэлтэй байна уу?' })
        await this.axios.delete(`/contracts/${id}`)
        _.remove(this.data[0], { id })
        this.data[1]--
        this.showToast('Амжилттай устгалаа.')
      } catch (err) {
        this.handleError(err)
      }
    },
    handleCreate () {
      this.itemId = null
      this.visible = true
    },
    handleEdit (id) {
      this.itemId = id
      this.visible = true
    },
    handleSaveSuccess (data) {
      const index = this.data[0].findIndex(c => c.id === data.id)
      if (index === -1) {
        this.data[0].push(data)
      } else {
        this.data[0].splice(index, 1, data)
      }
      this.visible = false
    }
  }
}
</script>
<style>
.input-container input {
    border: none;
    box-sizing: border-box;
    outline: 0;
    padding: .75rem;
    position: relative;
    width: 100%;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}
</style>
